module.exports = __webpack_public_path__ + "img/scene.ca311eef.png";